<template>
  <div v-if="hasMessages" id="messages">
    <transition-group :duration="250" name="zoom" mode="in-out" tag="div" class="callout alert" v-if="hasErrors">
      <p class="row align-center" v-for="error in errors" :key="error.key" @click="removeMessage(error.key)"><span class="columns" v-html="printMessage(error)"></span></p>
    </transition-group>
    <transition-group :duration="250" name="zoom" mode="in-out" tag="div" class="callout warning" v-if="hasWarnings">
      <p class="row align-center" v-for="warning in warnings" :key="warning.key" @click="removeMessage(warning.key)"><span class="columns" v-html="printMessage(warning)"></span></p>
    </transition-group>
    <transition-group :duration="250" name="zoom" mode="in-out" tag="div" class="callout success" v-if="hasStatuses">
      <p class="row align-center" v-for="status in statuses" :key="status.key" @click="removeMessage(status.key)"><span class="columns" v-html="printMessage(status)"></span></p>
    </transition-group>
  </div>
</template>

<script>
  // See https://www.npmjs.com/package/vue2-animate#supported-animations
  import 'vue2-animate/dist/vue2-animate.min.css';

  export default {
    name: 'Messages',
    props: {
      errors: Array,
      statuses: Array,
      warnings: Array
    },
    computed: {
      hasMessages() {
        return this.hasErrors || this.hasStatuses || this.hasWarnings
      },
      hasErrors() {
        return this.errors !== undefined && this.errors !== null && this.errors.length > 0
      },
      hasStatuses() {
        return this.statuses !== undefined && this.statuses !== null && this.statuses.length > 0
      },
      hasWarnings() {
        return this.warnings !== undefined && this.warnings !== null && this.warnings.length > 0
      },
    },
    methods: {
      removeMessage(key) {
        this.$store.commit('messages/removeMessage', key, {root: true})
      },
      printMessage(message) {
        return this.$options.filters.t(...[message.message, ...message.args])
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Messages.vue